import { ImportantMessage, ImportantMessageProps } from "lib-core"

export { ImportantMessage, ImportantMessageProps }
export default ImportantMessage
